import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import RadioGroup from '../RadioGroup';
import veneer1 from '../assets/interiorColors/nordic_oak.jpg';
import veneer2 from '../assets/interiorColors/teak.jpg';
import { withTranslation, Trans } from 'react-i18next';
import { saloon_view01ImageOptions } from './views/Saloon_view01'

class X56Interior extends Component {
    constructor(props) {
        super(props);
        this.handleDesignChange = this.handleDesignChange.bind(this);
        this.handleWoodChange = this.handleWoodChange.bind(this);
        this.handleHandrailChange = this.handleHandrailChange.bind(this);
        this.handleFloorboardChange = this.handleFloorboardChange.bind(this);

        this.designOptions = [
            { value: 1, label: 'Baltic' },
            { value: 0, label: 'Pacific' },
            { value: 2, label: 'Mediterranean' }
        ];

        this.woodOptions = [
            { value: 0, label: 'Oak', thumbnail: veneer1 },
            { value: 1, label: 'Teak', thumbnail: veneer2 }
        ];
    }

    handleDesignChange(newValue) {
        let configuration = this.props.configuration;
        let currentIndex = configuration.Veneer.value - 1;

        configuration.Veneer = this.props.designOptions[(newValue.value) + (currentIndex - (currentIndex % 3))];

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleHandrailChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Handrail = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleWoodChange(newValue) {
        let configuration = this.props.configuration;
        let currentIndex = configuration.Veneer.value - 1;

        configuration.Veneer = this.props.designOptions[(newValue.value * 3) + (currentIndex % 3)];
        configuration.Handrail = this.props.handrailOptions[newValue.value];

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleFloorboardChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Floorboard = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = saloon_view01ImageOptions;

        let image = <ConfiguratorImage boat="X5_6" configuration={this.props.configuration} options={imageOptions} />;

        let selectedDesign = this.designOptions.find(e => e.value === ((this.props.configuration.Veneer.value - 1) % 3));
        let selectedWood = this.woodOptions.find(e => e.value === (Math.floor((this.props.configuration.Veneer.value - 1) / 3)));

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Saloon' /></h1>
                    <h2><Trans defaults='Surfaces' /></h2>

                    <h3><b><Trans defaults='Styling Packages' /></b></h3>

                    <RadioGroup options={this.designOptions} value={selectedDesign} onChange={this.handleDesignChange} />

                    <h3><b><Trans defaults='Wood' /></b></h3>

                    <MaterialSelector label={selectedWood.label} options={this.woodOptions} value={selectedWood} onChange={this.handleWoodChange} />

                    <h3><Trans defaults='Laminate for floorboards' /></h3>

                    <MaterialSelector label={this.props.configuration.Floorboard.label} options={this.props.floorboardOptions} value={this.props.configuration.Floorboard} onChange={this.handleFloorboardChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56Interior);


// WEBPACK FOOTER //
// ./src/X56/X56Interior.js